import { CTBase } from "@ctsolution/ct-base";
import { CtSearchFilterControlConfiguration } from "@ctsolution/ct-framework";
import { NameFilter } from "./group-list.parameter";
import { GroupCodeFilter } from "./flow-common.parameter";
import { AddressBookTypeEnum } from "../interfaces/address-book-response";

export class AddressBookContactParameter extends CTBase<AddressBookContactParameter> {

    Oid: number | null = null;
    AddressBookOid: number | null = null;
    Name: string | null = null;
    Address: string | null = null;
    ZipCode: string | null = null;
    FiscalCode: string | null = null;
    City: string | null = null;
    Province: string | null = null;
    Country: string | null = null;
    Email: string | null = null;
    Phone: string | null = null;
    CertifiedEmail: string | null = null;
    ContactCode: string | null = null;
    GroupCode: string | null = null;
    AddressBookType : AddressBookTypeEnum | null = null;

    private constructor()
    private constructor(model?: AddressBookContactParameter);
    private constructor(model?: AddressBookContactParameter) {

        super();

        if (model) {

            this.getClass(model);

        }

    }

    public static create = (model?: AddressBookContactParameter): AddressBookContactParameter => new AddressBookContactParameter(model);

    setOid(value: number | null) {
        this.Oid = value;
        return this;
    }

    setAddressBookOid(value: number | null) {
        this.AddressBookOid = value;
        return this;
    }

    setName(value: string | null) {
        this.Name = value;
        return this;
    }

    setAddress(value: string | null) {
        this.Address = value;
        return this;
    }

    setZipCode(value: string | null) {
        this.ZipCode = value;
        return this;
    }

    setFiscalCode(value: string | null) {
        this.FiscalCode = value;
        return this;
    }

    setCity(value: string | null) {
        this.City = value;
        return this;
    }

    setProvince(value: string | null) {
        this.Province = value;
        return this;
    }

    setCountry(value: string | null) {
        this.Country = value;
        return this;
    }

    setEmail(value: string | null) {
        this.Email = value;
        return this;
    }

    setPhone(value: string | null) {
        this.Phone = value;
        return this;
    }

    setCertifiedEmail(value: string | null) {
        this.CertifiedEmail = value;
        return this;
    }

    setContactCode(value: string | null) {
        this.ContactCode = value;
        return this;
    }

    setGroupCode(value: string | null) {
        this.GroupCode = value;
        return this;
    }

    setAddressBookType(value: AddressBookTypeEnum | null) {
        this.AddressBookType = value;
        return this;
    }

}

export const ContactCodeFilter: CtSearchFilterControlConfiguration =
    CtSearchFilterControlConfiguration.create("ContactCode")
        .setLabel("Codice contatto");

export const AddressFilter: CtSearchFilterControlConfiguration =
    CtSearchFilterControlConfiguration.create("Address")
        .setLabel("Indirizzo");

export const CityFilter: CtSearchFilterControlConfiguration =
    CtSearchFilterControlConfiguration.create("City")
        .setLabel("Città");

export const EmailFilter: CtSearchFilterControlConfiguration =
    CtSearchFilterControlConfiguration.create("Email")
        .setLabel("Email");

export const FiscalCodeFilter: CtSearchFilterControlConfiguration =
    CtSearchFilterControlConfiguration.create("FiscalCode")
        .setLabel("Codice fiscale");

export const ZipCodeFilter: CtSearchFilterControlConfiguration =
    CtSearchFilterControlConfiguration.create("ZipCode")
        .setLabel("CAP");


export const AddressBookContactFilters: CtSearchFilterControlConfiguration[] = [NameFilter, AddressFilter, CityFilter, ZipCodeFilter, EmailFilter, FiscalCodeFilter, GroupCodeFilter, ContactCodeFilter];